import { isEqualWith, cloneDeep, isEqual, omit } from "lodash-es";
import { AppService } from "../../app.service";
import { DataProvider, SyncData } from "./data-provider";
import { console } from "#/log";

function skip$KeyField(value: unknown, other: unknown) {
  if (
    typeof value === "object" &&
    typeof other === "object" &&
    value !== null &&
    other !== null
  ) {
    /** Remote data can contain e.g. {$key: 'identifier' } which we should ignore */
    if ("$key" in value && !("$key" in other)) {
      return isEqual(omit(value, "$key"), other);
    }
    if (!("$key" in value) && "$key" in other) {
      return isEqual(value, omit(other, "$key"));
    }
  }
  return undefined;
}

/**
 * Inline test for validating that synchronization data has been set properly
 * (the target provider should now return the same sync data that was set)
 * */
export async function verifySyncData(
  syncTarget: DataProvider,
  sourceData: SyncData | null,
  sourceTimestamp: number,
  labels: { fn: string; source: string; target: string },
) {
  if (!AppService.isDevBuild()) return;
  const newTargetTimestamp = syncTarget.getLastUpdated();
  const newTargetData = await syncTarget.getSyncData();

  let errors = false;
  if (!isEqualWith(newTargetData, sourceData, skip$KeyField)) {
    errors = true;
    console.error(
      `${labels.fn}: updated ${labels.target} data DOES NOT MATCH ${labels.source}`,
      {
        [labels.source]: cloneDeep(sourceData),
        [labels.target]: cloneDeep(newTargetData),
      },
    );
  }
  if (newTargetTimestamp !== sourceTimestamp) {
    errors = true;
    console.error(
      `${labels.fn}: updated ${labels.target} timestamp DOES NOT MATCH ${labels.source}`,
      {
        [labels.source]: sourceTimestamp,
        [labels.target]: newTargetTimestamp,
      },
    );
  }
  if (!errors) {
    console.debug(`${labels.fn}: verification of data and timestamp success`);
  }
}
